import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { WorkflowModel } from '../../../model/workflowModel';
import { MessageModel, ContentPageModel } from '../../../model/models';
import { ActivatedRoute, Router } from '@angular/router';
import { BrokerAuditDeclarationService } from '../broker-audit-declaration.service';
import { StartFunctionService } from '../../../shared/utils/start-function.service';
import { CurrentPageWatcherService } from '../../../shared/utils/CurrentPageWatcher';
import { BrokerAuditDataModel } from '../../../model/brokerAuditDataModel';
import { SectionContentModel } from '../../../model/sectionContentModel';
import { SectionTextModel } from '../../../model/sectionTextModel';
import { BadQuestionnaireModel } from '../../../model/badQuestionnaireModel';
import { BadAnswerModel } from '../../../model/badAnswerModel';
import { BadSectionModel } from '../../../model/badSectionModel';
import { CompleteFunctionRequestModel } from '../../../model/completeFunctionRequestModel';
import { CompleteFunctionService } from '../../../shared/utils/complete-function.service';
import * as $ from 'jquery';
import { StorageService } from '../../../shared/security/StorageService';
import { StartFunctionResponseModel } from '../../../model/startFunctionResponseModel';
import { BadTrustAccountModel } from '../../../model/badTrustAccountModel';
import { StringUtils } from '../../../shared/utils/stringUtils';
import { BadOffSiteStorageLocationModel } from '../../../model/badOffSiteStorageLocationModel';
import { BadTransactionManagementSystemModel } from '../../../model/badTransactionManagementSystemModel';
import { BadPropertyManagementAccountingSystemModel } from '../../../model/badPropertyManagementAccountingSystemModel';
import { BadBrokerOwnedElectronicStorageSystemModel } from '../../../model/badBrokerOwnedElectronicStorageSystemModel';
import { BadNotBrokerOwnedElectronicStorageSystemModel } from '../../../model/badNotBrokerOwnedElectronicStorageSystemModel';

import { PdfStream } from '../../../shared/pdfStream';


import * as pdfMake from 'pdfmake/build/pdfmake.js';
import * as pdfFonts from 'pdfmake/build/vfs_fonts.js';
import { BadFileModelRequest } from '../../../model/badFileModelRequest';
import { CompleteFunctionResponseModel } from '../../../model/completeFunctionResponseModel';
import { SpinnerService } from '../../../shared/spinner/spinner.service';

pdfMake.vfs = pdfFonts.pdfMake.vfs;


@Component({
  selector: 'app-broker-audit-declaration-review',
  templateUrl: './broker-audit-declaration-review.component.html',
  styleUrls: ['./broker-audit-declaration-review.component.css']
})
export class BrokerAuditDeclarationReviewComponent implements OnInit, OnDestroy {

  headerContent: SectionContentModel = new SectionContentModel;
  workflow: WorkflowModel = new WorkflowModel();
  brokerAuditDataModel: BrokerAuditDataModel = new BrokerAuditDataModel();

  badQuestionnaireDataModel: BadQuestionnaireModel = new BadQuestionnaireModel();
  questionnaireSections :  Array<BadSectionModel> = [];
  badAffirmation1 : boolean = false;
  badAffirmation2 : boolean = false;
  userMessages: Array<MessageModel> = [];
  startFunction: StartFunctionResponseModel;
  
  badFileRequest: BadFileModelRequest;
  completeFunctionRequest: CompleteFunctionRequestModel;
  completeFunctionResponse: CompleteFunctionResponseModel = new CompleteFunctionResponseModel();

  public headerDate = new Date();
  startStepMessageContent: ContentPageModel;

  constructor(private route: ActivatedRoute,
    private router: Router,
    private brokerAuditDeclarationService: BrokerAuditDeclarationService,
    private startFunctionService: StartFunctionService,
    private currentPageWatcher: CurrentPageWatcherService,
    private completeFunctionService: CompleteFunctionService,
    private spinner: SpinnerService,
    private storageService: StorageService, private pdfStream: PdfStream,private stringUtils: StringUtils) {

    //create header content message
    let textModel: SectionTextModel = new SectionTextModel();
    textModel.text = "Please review the following information for accuracy. If you need to make any changes click the Back button to reach the appropriate page. Once you have verified your submission read the affirmation below, check the box and click the Continue button.";
    this.headerContent.textList.push(textModel);

    this.currentPageWatcher.sendHeaderContent(this.headerContent);

  }

  ngOnInit() {

    this.startFunction = this.storageService.getStartFunctionData();

    this.workflow = this.brokerAuditDeclarationService.brokerAuditDeclarationWorkflowModel;
    this.startStepMessageContent = this.startFunction.Workflow.Steps[0].StepMessage;
    //set startStepMessageContent.Sections[1].lists to display business information and business address
    this.startStepMessageContent.Sections[1].Lists[0].Title.StringContent = "Business Information";
    this.startStepMessageContent.Sections[1].Lists[1].Title.StringContent = "Business Address";
    this.brokerAuditDataModel = this.brokerAuditDeclarationService.brokerAuditDataModel;

    //filter list
    this.filterBrokerAuditDataModelTables(this.brokerAuditDataModel);

    // get questionnaire data model
    this.badQuestionnaireDataModel = this.brokerAuditDeclarationService.badQuestionnaireDataModel;

    this.badQuestionnaireDataModel.Sections.forEach(section => {
      section.Questions.forEach(question => {
        // find answer by QuestionID from this.brokerAuditDeclarationService.badQuestionnaireDataModel.Answers
        //if no answer, then add question with N/A answer
        if (this.badQuestionnaireDataModel.Answers.filter(a => a.QuestionID == question.QuestionID) == undefined || this.badQuestionnaireDataModel.Answers.filter(a => a.QuestionID == question.QuestionID).length == 0) {
          question.Answer = new BadAnswerModel();
          question.Answer.AnswerTypeID = 3;
        }
        else {
          //add found answer in badQuestionnaireDataModel by QuestionID 
          question.Answer = this.badQuestionnaireDataModel.Answers.filter(a => a.QuestionID == question.QuestionID)[0];

        }
      }

      );
    });
  }


      

  completeFunction() {
    this.currentPageWatcher.clearUserMessage();
    this.currentPageWatcher.clearHeaderContent();
   
    if (this.badAffirmation1 && this.badAffirmation2){
      //set review affirmation list to emit to receipt page
      let reviewAffirmationList = [];
      reviewAffirmationList.push(this.badAffirmation1);
      reviewAffirmationList.push(this.badAffirmation2);

      this.currentPageWatcher.sendUserMessages(null);
      this.completeFunctionRequest = new CompleteFunctionRequestModel();
      this.completeFunctionRequest.WorkflowID = this.workflow.WorkflowID;
      this.completeFunctionRequest.CurrentStepIndex = this.workflow.CurrentStepIndex;
      this.completeFunctionRequest.OrderNumber = null;

      this.completeFunctionService.completeFunction(this.completeFunctionRequest).subscribe(completeFunctionResp => {
        console.log("completeFunctionResp:  ", completeFunctionResp);
        if (completeFunctionResp.UserMessages != undefined) {
          completeFunctionResp.UserMessages.forEach(el => {
            this.userMessages.push(el);
          });
        }
        this.currentPageWatcher.sendUserMessages(this.userMessages);
        if (completeFunctionResp.Summary == 0) {
          this.brokerAuditDeclarationService.brokerAuditDeclarationWorkflowModel = completeFunctionResp.Workflow;
          this.completeFunctionResponse = completeFunctionResp;
          this.buildBase64(this.brokerAuditDataModel);
          
          this.router.navigate(['/brokerAuditDeclarationReceipt']).then(() => {
            this.startFunctionService.getNotifyStepInProgress().emit(true);
            this.completeFunctionService.getNotifyCompleteFunctionResponse().emit(completeFunctionResp);
            this.brokerAuditDeclarationService.getNotifyBrokerAuditReviewAffirmations().emit(reviewAffirmationList); 
      
         });
          this.userMessages = [];
        }
        if (completeFunctionResp.Summary == 1) {
          $("html, body").animate({ scrollTop: 0 }, "slow");
          this.userMessages = [];
        }
        if (completeFunctionResp.Summary == 2) {
          this.router.navigate(["/home"]);
          this.userMessages = [];
        }
      },
      );
    }
    else {
      let userMessage: MessageModel = {};
      userMessage.Alert = 3;
      userMessage.Description = "You must accept the terms of the Broker Audit Declaration by clicking the checkboxes below.";
      this.userMessages.push(userMessage);
      $("html, body").animate({ scrollTop: 0 }, "slow");
      this.currentPageWatcher.sendUserMessages(this.userMessages);
      this.userMessages = [];
    }

  }

  
 
  buildBase64(badataModel: BrokerAuditDataModel){
  
    this.filterBrokerAuditDataModelTables(badataModel); 
    const pdfDocGenerator = pdfMake.createPdf(this.pdfStream.makePdf( badataModel, this.badQuestionnaireDataModel, this.workflow,this.completeFunctionResponse,true,true));
    pdfDocGenerator.getBase64((stream) => {
      this.badFileRequest = new BadFileModelRequest();
      this.badFileRequest.WorkflowID = this.workflow.WorkflowID;
      this.badFileRequest.FileData =stream;
     this.brokerAuditDeclarationService.submitBadFile(this.badFileRequest).subscribe(badFileResp => {
       console.log("badFileResp");  

       console.log("pushing success message");  

       let userMessage: MessageModel = {};
       userMessage.Alert = 0;
       userMessage.Description = "Broker Audit Declaration successfully submitted";
       this.spinner.hide();
       this.currentPageWatcher.clearUserMessage();
       this.userMessages = [];
       this.userMessages.push(userMessage);
       this.currentPageWatcher.sendUserMessages(this.userMessages);

     },
     err => {
       console.log(err);
       if (err.status != 200) {
        this.userMessages = [];
         this.spinner.hide();
       }
     }
     );
    });
  }
 

onSubmit(){
  //1 : submit bad questionnaire ; 2 : complete function
  this.brokerAuditDeclarationService.submitBrokerAuditQuestionnaireRequestModel.SubmitAsDraft = false;
  this.brokerAuditDeclarationService.submitBrokerAuditDeclarationQuestionnaire( this.brokerAuditDeclarationService.submitBrokerAuditQuestionnaireRequestModel)
    .subscribe(response=>{
      console.log("submitBrokerAuditDeclarationQuestionnaire response : ",response);
      response.UserMessages.forEach(msg => {
        this.userMessages.push(msg);
      })
      this.currentPageWatcher.sendUserMessages(this.userMessages);

      if (response.Summary == 0) {
        //update BAD workflow informations (brokerAuditDeclarationService.brokerAuditDeclarationWorkflowModel is shared)
        this.brokerAuditDeclarationService.brokerAuditDeclarationWorkflowModel = response.Workflow;
        //save startFunction with updated workflow in localstorage
        this.brokerAuditDeclarationService.updateStartFunction(this.startFunction);
        
        this.completeFunction();
       
        this.userMessages = [];
      }
      if (response.Summary == 1) {
        $("html, body").animate({ scrollTop: 0 }, "slow");
        this.userMessages = [];

      }

      if (response.Summary == 2) {
        this.router.navigate(["/home"]);
        this.userMessages = [];
      }
    },
    err=>{
      console.log("error: ",err);
    });
}




filterBrokerAuditDataModelTables(badataModel: BrokerAuditDataModel) {
  this.filterGeneralTrustAccounts(badataModel);
  this.filterPropMgntTrustAccounts(badataModel);
  this.filterOffSiteStorageLocations(badataModel);
  this.filterTransactionMgntSystems(badataModel);
  this.filterPropMgntAccounting(badataModel);
  this.filterOwnedElectronics(badataModel);
  this.filterNotOwnedElectronics(badataModel);
}


 filterGeneralTrustAccounts(badataModel: BrokerAuditDataModel) {
  if(badataModel.GeneralTrustAccounts != undefined && badataModel.GeneralTrustAccounts.length>0){
    let trustAccounts: Array<BadTrustAccountModel> = badataModel.GeneralTrustAccounts;
    let trustAccoutsFiltered: Array<BadTrustAccountModel> = [];
    trustAccounts.forEach(el => {
      if (this.stringUtils.isNotEmpty(el.Title)
        && this.stringUtils.isNotEmpty(el.AccountNumber) && this.stringUtils.isNotEmpty(el.FinancialInstitutionName)
        && this.stringUtils.isNotEmpty(el.FinanialInstitutionAddress)) {
        trustAccoutsFiltered.push(el);
      }
    });
    this.brokerAuditDataModel.GeneralTrustAccounts = trustAccoutsFiltered;
 }
}

filterPropMgntTrustAccounts(badataModel: BrokerAuditDataModel) {
  if(badataModel.PropertyManagementTrustAccounts != undefined && badataModel.PropertyManagementTrustAccounts.length>0){
    let propMngtTrustAccounts: Array<BadTrustAccountModel> = badataModel.PropertyManagementTrustAccounts;
    let propMngtTrustAccoutsFiltered: Array<BadTrustAccountModel> = [];
    propMngtTrustAccounts.forEach(el => {
      if (this.stringUtils.isNotEmpty(el.Title)
        && this.stringUtils.isNotEmpty(el.AccountNumber) && this.stringUtils.isNotEmpty(el.FinancialInstitutionName)
        && this.stringUtils.isNotEmpty(el.FinanialInstitutionAddress)) {
          propMngtTrustAccoutsFiltered.push(el);
      }
    });
    this.brokerAuditDataModel.PropertyManagementTrustAccounts = propMngtTrustAccoutsFiltered;
  }
}

filterOffSiteStorageLocations(badataModel: BrokerAuditDataModel) {
  if(badataModel.OffSiteStorageLocations != undefined && badataModel.OffSiteStorageLocations.length>0){
    let offSiteStorageLocations: Array<BadOffSiteStorageLocationModel> = badataModel.OffSiteStorageLocations;
    let offSiteStorageLocationsFiltered: Array<BadOffSiteStorageLocationModel> = [];
    offSiteStorageLocations.forEach(el => {
      if (this.stringUtils.isNotEmpty(el.FacilityName)
        && this.stringUtils.isNotEmpty(el.FacilityAddress) ) {
          offSiteStorageLocationsFiltered.push(el);
      }
    });
    this.brokerAuditDataModel.OffSiteStorageLocations = offSiteStorageLocationsFiltered;
  }
}

filterTransactionMgntSystems(badataModel: BrokerAuditDataModel) {
  if(badataModel.TransactionManagementSystems != undefined && badataModel.TransactionManagementSystems.length>0){
    let transactionMgntSystems: Array<BadTransactionManagementSystemModel> = badataModel.TransactionManagementSystems;
    let transactionMgntFiltered :Array<BadTransactionManagementSystemModel> = [];
    transactionMgntSystems.forEach(el => {
      if (this.stringUtils.isNotEmpty(el.SystemName)
        && this.stringUtils.isNotEmpty(el.ProviderAddress) && this.stringUtils.isNotEmpty(el.DatesUsed)) {
          transactionMgntFiltered.push(el);
      }
    });
    this.brokerAuditDataModel.TransactionManagementSystems = transactionMgntFiltered;
  }
}

filterPropMgntAccounting(badataModel: BrokerAuditDataModel) {
  if(badataModel.PropertyManagementAccountingSystems != undefined && badataModel.PropertyManagementAccountingSystems.length>0){
    let propMgntAccountingSystems: Array<BadPropertyManagementAccountingSystemModel> = badataModel.PropertyManagementAccountingSystems;
    let propMgntAccountingFiltered :Array<BadPropertyManagementAccountingSystemModel> = [];
    propMgntAccountingSystems.forEach(el => {
      if (this.stringUtils.isNotEmpty(el.SystemName)
        && this.stringUtils.isNotEmpty(el.ProviderAddress) && this.stringUtils.isNotEmpty(el.DatesUsed)) {
          propMgntAccountingFiltered.push(el);
      }
    });
    this.brokerAuditDataModel.PropertyManagementAccountingSystems = propMgntAccountingFiltered;
  }
}



filterOwnedElectronics(badataModel: BrokerAuditDataModel) {
  if(badataModel.BrokerOwnedElectronicStorageSystems != undefined && badataModel.BrokerOwnedElectronicStorageSystems.length>0){
    let ownedElectronicsSystems: Array<BadBrokerOwnedElectronicStorageSystemModel> = badataModel.BrokerOwnedElectronicStorageSystems;
    let ownedElectronicsFiltered :Array<BadBrokerOwnedElectronicStorageSystemModel> = [];
    ownedElectronicsSystems.forEach(el => {
      if (this.stringUtils.isNotEmpty(el.StorageType)
        && this.stringUtils.isNotEmpty(el.Location)) {
          ownedElectronicsFiltered.push(el);
      }
    });
    this.brokerAuditDataModel.BrokerOwnedElectronicStorageSystems = ownedElectronicsFiltered;
  }
}

filterNotOwnedElectronics(badataModel: BrokerAuditDataModel) {
  if(badataModel.NotBrokerOwnedElectronicStorageSystems != undefined && badataModel.NotBrokerOwnedElectronicStorageSystems.length>0){
    let notOwnedElectronicsSystems: Array<BadNotBrokerOwnedElectronicStorageSystemModel> = badataModel.NotBrokerOwnedElectronicStorageSystems;
    let notOwnedElectronicsFiltered :Array<BadNotBrokerOwnedElectronicStorageSystemModel> = [];
    notOwnedElectronicsSystems.forEach(el => {
      if (this.stringUtils.isNotEmpty(el.SystemName)
        && this.stringUtils.isNotEmpty(el.VendorContact)) {
          notOwnedElectronicsFiltered.push(el);
      }
    });
    this.brokerAuditDataModel.NotBrokerOwnedElectronicStorageSystems = notOwnedElectronicsFiltered;
  }
}


  ngOnDestroy(): void {
    this.currentPageWatcher.clearHeaderContent();
    this.currentPageWatcher.clearUserMessage();
    this.currentPageWatcher.clearHeaderContent();

  }

  back(){
    this.currentPageWatcher.clearHeaderContent();
    this.router.navigate(['/questionnaireAuditDeclarationComment']).then(()=>{
      this.startFunctionService.getNotifyStepInProgress().emit(false);
      this.brokerAuditDeclarationService.brokerAuditDeclarationWorkflowModel.CurrentStepIndex = this.workflow.CurrentStepIndex - 1;
    });
  }

  //back browser button
  @HostListener('window:popstate', ['$event'])
  onPopState(event) {
    this.back();
  }
}



// WEBPACK FOOTER //
// ./src/app/broker/broker-audit-declaration/broker-audit-declaration-review/broker-audit-declaration-review.component.ts